import React, { useEffect, useState } from 'react';
import {
  Typography,
  Container,
  Button,
  List,
  ListItem,
  ListItemText,
  Checkbox,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTeachersByGroup, assignTeacherToGroup, unassignTeacherFromGroup } from '../actions/groupActions';
import { fetchUsers } from '../actions/userActions';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const ManageTeachers = () => {
  const { groupId } = useParams();
  const dispatch = useDispatch();
  const [selectedTeachers, setSelectedTeachers] = useState([]);
  const [originalTeachers, setOriginalTeachers] = useState([]);
  const teachers = useSelector((state) => state.users.users.filter((user) => user.role_name === 'teacher'));
  const groupTeachers = useSelector((state) => state.groups.groupTeachers[groupId] || []);
  
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchTeachersByGroup(groupId));
  }, [dispatch, groupId]);

  useEffect(() => {
    const assignedTeacherIds = groupTeachers.map((teacher) => teacher.user_id);
    setSelectedTeachers(assignedTeacherIds);
    setOriginalTeachers(assignedTeacherIds);
  }, [groupTeachers]);

  const handleToggle = (user_id) => () => {
    const currentIndex = selectedTeachers.indexOf(user_id);
    const newSelected = [...selectedTeachers];

    if (currentIndex === -1) {
      newSelected.push(user_id);
    } else {
      newSelected.splice(currentIndex, 1);
    }

    setSelectedTeachers(newSelected);
  };

  const handleSave = () => {
    const teachersToAssign = selectedTeachers.filter((id) => !originalTeachers.includes(id));
    const teachersToUnassign = originalTeachers.filter((id) => !selectedTeachers.includes(id));
  
    // Dispatch actions to assign/unassign teachers
    Promise.all([
      ...teachersToAssign.map((user_id) => dispatch(assignTeacherToGroup(groupId, user_id))),
      ...teachersToUnassign.map((user_id) => dispatch(unassignTeacherFromGroup(groupId, user_id))),
    ])
      .then(() => {
        setOriginalTeachers([...selectedTeachers]);
        setTimeout(() => {
          navigate('/admin');
        }, 1000);
      })
      .catch((error) => {
        console.error('Error at Teacher linkage/unlinkage')
      });
  };
  

  return (
    <Container>
      <Typography variant="h5" gutterBottom>
        Gestionare Educatori pentru Grupă: {groupId}
      </Typography>
      <List>
        {teachers.map((teacher) => (
          <ListItem key={teacher.user_id} button onClick={handleToggle(teacher.user_id)}>
            <Checkbox checked={selectedTeachers.indexOf(teacher.user_id) !== -1} />
            <ListItemText primary={teacher.name} secondary={teacher.email} />
          </ListItem>
        ))}
      </List>
      <Button variant="contained" color="primary" onClick={handleSave} style={{ marginTop: '16px' }}>
        Salvează
      </Button>
    </Container>
  );
};

export default ManageTeachers;
